export default "__VITE_PUBLIC_ASSET__67582e55__"